import script from "./GradientText.vue?vue&type=script&setup=true&lang=js"
export * from "./GradientText.vue?vue&type=script&setup=true&lang=js"

import "./GradientText.vue?vue&type=style&index=0&id=9c5aa394&lang=scss&scoped=true"

import exportComponent from "/PPPoker/kkpoker-anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c5aa394"]])

export default __exports__